import type {
  ActivityFeedEventType,
  ActivityFeedRowDTO,
  ActivityFeedSnapshotKind,
} from '../../../services/modules/activityFeed/activityFeed.types';

const SNAPSHOT_KIND_BY_EVENT_TYPE: Partial<
  Record<ActivityFeedEventType, ActivityFeedSnapshotKind>
> = {
  'order.created': 'order-history',
  'order.status.updated': 'order-history',
  'order.integration_status.updated': 'order-integration-result',
};

export const resolveActivityFeedSnapshotKind = ({
  eventType,
  hasSnapshot,
}: Pick<ActivityFeedRowDTO, 'eventType' | 'hasSnapshot'>) =>
  hasSnapshot ? SNAPSHOT_KIND_BY_EVENT_TYPE[eventType] : undefined;

export const resolveActivityFeedOrderCode = ({ refs, payload }: ActivityFeedRowDTO) =>
  refs.orderCode ?? ('orderCode' in payload ? payload.orderCode : undefined);
